import { NOTIFY_USER } from './types';

export const notifyUser = (message, messageType) => {
  return {
    type: NOTIFY_USER,
    message,
    messageType,
  };
};



// WEBPACK FOOTER //
// ./src/actions/notifyActions.js